<template>
  <div class="home">
    <div class="typewriter" ref="typewriter"></div>
    <!-- <ul class="ulmenu">
      <li><a><img src="@/assets/twitter.png" target="_blank" /></a></li>
      <li><a><img src="@/assets/ins.png" target="_blank" /></a></li>
      <li><a><img src="@/assets/face.png" target="_blank" /></a></li>
    </ul> -->
  </div>

  <div class="home-two" :style="{ backgroundImage: `url(${backgroundImages[currentBackgroundIndex]})` }"
    v-if="slidesPerView == 2">
    <div class="home-two-title wow animate__fadeInUp">
      <h1> Our Experience </h1>
    </div>
    <div class="home-two-content">
      <div class="contents">
        <div @mouseover="changeBackground(1)" @mouseout="resetBackground">
          <div>
            <h3 class="wow animate__fadeInUp">On Air Events</h3>
            <p class="wow animate__fadeInUp">On Air Events' Winning Strategy for User Acquisition and Retention</p>
          </div>
        </div>
        <div @mouseover="changeBackground(2)" @mouseout="resetBackground">
          <div>
            <h3 class="wow animate__fadeInUp" data-wow-delay="0.1s"> Film and Television</h3>
            <p class="wow animate__fadeInUp" data-wow-delay="0.1s">Establishing an innovative and sustainable marketing
              model
            </p>
          </div>
        </div>
        <div @mouseover="changeBackground(3)" @mouseout="resetBackground">
          <div>
            <h3 class="wow animate__fadeInUp" data-wow-delay="0.2s">Technology</h3>
            <p class="wow animate__fadeInUp" data-wow-delay="0.2s">Managing confidential innovative research for Fortune
              500 companies
            </p>
          </div>
        </div>
        <div @mouseover="changeBackground(4)" @mouseout="resetBackground">
          <div>
            <h3 class="wow animate__fadeInUp" data-wow-delay="0.3s">Gaming</h3>
            <p class="wow animate__fadeInUp" data-wow-delay="0.3s">Managed the gaming division for a global conglomerate
            </p>
          </div>
        </div>
        <div @mouseover="changeBackground(5)" @mouseout="resetBackground">
          <div>
            <h3 class="wow animate__fadeInUp" data-wow-delay="0.4s">Project Management</h3>
            <p class="wow animate__fadeInUp" data-wow-delay="0.4s">Digital engagement for a reality series with 10+
              million Fans
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="home-two" :style="{ backgroundImage: `url(${backgroundImages[0]})` }" v-else>
    <div class="home-two-title wow animate__fadeInUp">
      <h1> Our Experience </h1>
    </div>
    <div class="swiper-container1" :style="{ width: '90%', margin: '0 auto' }">
      <swiper :slides-per-view="slidesPerView" :space-between="30" @swiper="onSwiper1" :slides-per-group="slidesPerView"
        loop="true">
        <swiper-slide>
          <div style="color: #fff;width: 70%;margin: auto;">
            <h3 class="wow animate__fadeInUp">On Air Events</h3>
            <p class="wow animate__fadeInUp">On Air Events' Winning Strategy for User Acquisition and Retention</p>
          </div>
        </swiper-slide>
        <swiper-slide>
          <div style="color: #fff;width: 70%;margin: auto;">
            <h3 class="wow animate__fadeInUp" data-wow-delay="0.1s"> Film and Television</h3>
            <p class="wow animate__fadeInUp" data-wow-delay="0.1s">Establishing an innovative and sustainable marketing
              model
            </p>
          </div>
        </swiper-slide>
        <swiper-slide>
          <div style="color: #fff;width: 70%;margin: auto;">
            <h3 class="wow animate__fadeInUp" data-wow-delay="0.2s">Technology</h3>
            <p class="wow animate__fadeInUp" data-wow-delay="0.2s">Managing confidential innovative research for Fortune
              500 companies</p>
          </div>
        </swiper-slide>
        <swiper-slide>
          <div style="color: #fff;width: 70%;margin: auto;">
            <h3 class="wow animate__fadeInUp">Gaming</h3>
            <p class="wow animate__fadeInUp">Managed the gaming division for a global conglomerate</p>
          </div>
        </swiper-slide>
        <swiper-slide>
          <div style="color: #fff;width: 70%;margin: auto;">
            <h3 class="wow animate__fadeInUp">Project Management</h3>
            <p class="wow animate__fadeInUp">Digital engagement for a reality series with 10+
              million Fans
            </p>
          </div>
        </swiper-slide>
      </swiper>
      <div class="swiper-button-prev" @click="slidePrev1"><img width="100%" src="@/assets/btn-prev-light.png" /></div>
      <div class="swiper-button-next" @click="slideNext1"><img width="100%" src="@/assets/btn-prev-light.png" /></div>
    </div>
  </div>

  <div class="home-three">
    <div class="home-three-title wow animate__fadeInUp">
      <h1> Our Work </h1>
    </div>
    <div class="swiper-container">
      <div class="swiper-container1" :style="{ width: '90%', margin: '0 auto' }">
        <swiper :slides-per-view="slidesPerView" :space-between="30" @swiper="onSwiper" @slideChange="onSlideChange"
          :slides-per-group="slidesPerView" loop="true">
          <swiper-slide>
            <div class="slide-content">
              <img src="@/assets/home-three-icon1.png" />
              <h1>CNN brasil</h1>
              <h3>SEO and Content Management</h3>
              <p>In search of 1 billion pageviews. CNN’s holistic SEO and content strategy grew its search audience by
                91%.
                According to ComScore, the CNN Brasil website enters the Top 10, occupying the seventh ranking position
                in the “News and Information” category.</p>
              <em>Sao Paulo, Brazil</em>
              <div @click="goTo('indiaLegends')">></div>
            </div>
          </swiper-slide>
          <swiper-slide>
            <div class="slide-content" :style="{ marginTop: (slidesPerView == 2) ? '80px' : '0px' }">
              <img src="@/assets/home-three-icon2.png" />
              <h1>On Air Events</h1>
              <h3>Navigating the Digital Event Landscape</h3>
              <p>The partnership between On Air Events and MYD proved to be a winning formula. The cohesive approach
                towards user acquisition, engagement, and retention has demonstrated its effectiveness in achieving
                business objectives. The impressive growth in user base, conversion rates and repeat purchases are
                testament to this success.</p>
              <em>Utrecht, Netherlands</em>
              <div @click="goTo('flooterTwo')">></div>
            </div>
          </swiper-slide>
          <swiper-slide>
            <div class="slide-content">
              <img src="@/assets/home-three-icon.png" />
              <h1>ITERATE</h1>
              <h3>Innovative Strategy and Curation</h3>
              <p> We provide some of the biggest Corporations (USA, Canada, Europe) with Market Landscaping and
                Innovative
                Strategy Solutions including technology and service solutions for customer engagement blueprints,
                technical due diligence and emerging technology application. With our seasoned team of Researchers and
                the
                knowledge of business strategies, we provide tailor-made and innovative solutions that help Global
                leaders
                in Fashion, Retail, Sports and other industries, work with agile solutions. </p>
              <em>California, U.S.A</em>
              <div @click="goTo('flooterThree')">></div>
            </div>
          </swiper-slide>
          <swiper-slide>
            <div class="slide-content" :style="{ marginTop: (slidesPerView == 2) ? '80px' : '0px' }">
              <img src="@/assets/footerview/footer-one-icon.png" />
              <h1>TuneVu</h1>
              <h3>Content Curation & User Engagement</h3>
              <p> We work with a unique second screen emerging podcast platform from Canada to furnish the Application
                with engaging and interactive content, curated from more than 1000 podcasts monthly to create user
                engagement. Our work includes identifying engagement points and creating content interstitials related
                to those topics. This makes it easy for the listener to access relevant information and remain engaged
                with the platform through a second screen. </p>
              <em>Ontario, Canada</em>
              <div @click="goTo('flooterOne')">></div>
            </div>
          </swiper-slide>
        </swiper>
        <div class="swiper-button-prev" @click="slidePrev"><img width="100%" src="@/assets/btn-next.png" /></div>
        <div class="swiper-button-next" @click="slideNext"><img width="100%" src="@/assets/btn-next.png" /></div>
      </div>
    </div>
  </div>

  <div class="home-six">
    <div class="home-six-title">
      <h1 style="text-transform: uppercase;" class="wow animate__fadeInUp" data-wow-delay="0.1s"> Our Services </h1>
      <div class="wow animate__fadeInUp" data-wow-delay="0.2s">
        MYD delivers a range of services across five pillars of execution with the main objective of helping our clients
        build their legacy
      </div>
    </div>
    <div class="home-six-content" v-if="slidesPerView == 2">
      <div class="wow animate__fadeInUp" data-wow-delay="0.1s">
        <div>
          <div>01</div>
          <div style="font-size: 1vw;">
            <p style="font-weight: 500;"> Harnessing Brand Engagement </p>
            <p> Building brand social ecosystems and reach </p>
          </div>
        </div>
      </div>
      <div class="wow animate__fadeInUp" data-wow-delay="0.2s">
        <div>
          <div>02</div>
          <div style="font-size: 1vw;">
            <p style="font-weight: 500;"> Telling your Story </p>
            <p> Creating compelling communication for your brand </p>
          </div>
        </div>
      </div>
      <div class="wow animate__fadeInUp" data-wow-delay="0.3s">
        <div>
          <div>03</div>
          <div style="font-size: 1vw;">
            <p style="font-weight: 500;"> Graphic Visualisation & Creation </p>
            <p> Bringing life to your message through media & art </p>
          </div>
        </div>
      </div>
      <div class="wow animate__fadeInUp" data-wow-delay="0.4s">
        <div>
          <div>04</div>
          <div style="font-size: 1vw;">
            <p style="font-weight: 500;"> Digital Outreach </p>
            <p> Right representation of your digital identity </p>
          </div>
        </div>
      </div>
      <div class="wow animate__fadeInUp" data-wow-delay="0.5s">
        <div>
          <div>05</div>
          <div style="font-size: 1vw;">
            <p style="font-weight: 500;"> Building Your Products </p>
            <p> Conceptualisation to build for your Digital products and Applications </p>
          </div>
        </div>
      </div>
    </div>

    <div class="swiper-container1" :style="{ width: '90%',}" v-else>
      <swiper :slides-per-view="slidesPerView" :space-between="30" @swiper="onSwiper2" :slides-per-group="slidesPerView"
        loop="true">
        <swiper-slide>
          <div class="six-slide">
            <div>01</div>
            <div style="font-size: 12px;">
              <p style="font-weight: 500;font-size: 14px;"> Harnessing Brand Engagement </p>
              <p> Building brand social ecosystems and reach </p>
            </div>
          </div>
        </swiper-slide>
        <swiper-slide>
          <div class="six-slide">
            <div>02</div>
            <div style="font-size: 12px;">
              <p style="font-weight: 500;font-size: 14px;"> Telling your Story </p>
              <p> Creating compelling communication for your brand </p>
            </div>
          </div>
        </swiper-slide>
        <swiper-slide>
          <div class="six-slide">
            <div>03</div>
            <div style="font-size: 12px;">
              <p style="font-weight: 500;font-size: 14px;"> Graphic Visualisation & Creation </p>
              <p> Bringing life to your message through media & art </p>
            </div>
          </div>
        </swiper-slide>
        <swiper-slide>
          <div class="six-slide">
            <div>04</div>
            <div style="font-size: 12px;">
              <p style="font-weight: 500;font-size: 14px;"> Digital Outreach </p>
              <p> Right representation of your digital identity </p>
            </div>
          </div>
        </swiper-slide>
        <swiper-slide>
          <div class="six-slide">
            <div>05</div>
            <div style="font-size: 12px;">
              <p style="font-weight: 500;font-size: 14px;"> Building Your Products </p>
              <p> Conceptualisation to build for your Digital products and Applications </p>
            </div>
          </div>
        </swiper-slide>
      </swiper>
      <div class="swiper-button-prev" @click="slidePrev2"><img width="100%" src="@/assets/btn-prev-light.png" /></div>
      <div class="swiper-button-next" @click="slideNext2"><img width="100%" src="@/assets/btn-prev-light.png" /></div>
    </div>
  </div>

  <div class="home-fore">
    <div class="home-fore-title">
      <h1 style="text-transform: uppercase;" class="wow animate__fadeInUp" data-wow-delay="0.1s"> Were you ready for
        Covid-19 ? </h1>
      <div class="wow animate__fadeInUp" data-wow-delay="0.2s">
        Are you ready for the next pandemic ?<br />
        Are you ready for low sales ?<br />
        Are you prepared for working from home ?<br />
        Prepared to pivot your strategy ?
      </div>
      <div style="cursor: pointer;" class="wow animate__fadeInUp" data-wow-delay="0.3s" @click="goTo('flooterFour')">
        Learn more</div>
    </div>
  </div>

  <div class="home-five" ref="homeFive">
    <h1 class="wow animate__fadeInUp" data-wow-delay="0.1s">Connect</h1>
    <h3>Help us with your requirement & let us build your solution</h3>
    <div><a href="mailto:Hello@mydigim.com?subject=Hello&body=This is a email.">Send</a></div>
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue';
import { useRouter } from 'vue-router';
import { Swiper, SwiperSlide } from 'swiper/vue';
import 'swiper/swiper-bundle.css';

const typewriter = ref(null);
const homeFive = ref(null);
let observer = null;

const backgroundImages = ref([
  require('@/assets/home-two-bg.jpg'), // 默认背景图
  require('@/assets/change1.png'), // 第二张背景图
  require('@/assets/change2.png'), // 第三张背景图
  require('@/assets/change3.png'), // 第四张背景图
  require('@/assets/change4.png'),  // 第五张背景图
  require('@/assets/change5.png')  // 第五张背景图
]);
const currentBackgroundIndex = ref(0);

const swiperInstance = ref(null);
const slidesPerView = ref(1);

const swiperInstance1 = ref(null);
const swiperInstance2 = ref(null);


const router = useRouter();
const goTo = (name) => {
  router.push({ name });
};

const changeBackground = (index) => {
  currentBackgroundIndex.value = index; // 确保索引从1开始，0是默认背景图
};
const resetBackground = () => {
  currentBackgroundIndex.value = 0; // 恢复默认背景图
};
onMounted(() => {
  updateSlidesPerView();
  window.addEventListener('resize', updateSlidesPerView);

  const textElement = typewriter.value;
  const fullText = 'Transform your business with My Digital Marketing services We offer a wide range of digital marketing services designed to meet the unique needs of all our clients.';
  let index = 0;
  const speed = 100; // 打字速度（毫秒）

  const typeWriter = () => {
    if (index < fullText.length) {
      textElement.innerText += fullText.charAt(index);
      index++;
      setTimeout(typeWriter, speed);
    }
  };

  typeWriter();
  observer = new IntersectionObserver(handleIntersection, {
    threshold: 0.05 // 当元素 10% 进入视口时触发
  });
  if (homeFive.value) {
    observer.observe(homeFive.value);
  }
});

onUnmounted(() => {
  if (observer && homeFive.value) {
    observer.unobserve(homeFive.value);
  }
  window.removeEventListener('resize', updateSlidesPerView);
});
const handleIntersection = (entries) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      entry.target.classList.add('clip-path-effect');
    } else {
      entry.target.classList.remove('clip-path-effect');
    }
  });
};
const updateSlidesPerView = () => {
  slidesPerView.value = window.innerWidth < 600 ? 1 : 2;
};

const onSwiper = (swiper) => {
  swiperInstance.value = swiper;
};
const onSlideChange = () => {
  console.log('slide change');
};
const slidePrev = () => {
  if (swiperInstance.value) {
    swiperInstance.value.slidePrev();
  }
};
const slideNext = () => {
  if (swiperInstance.value) {
    swiperInstance.value.slideNext();
  }
};
//-------------------------------------------copy
const onSwiper1 = (swiper) => {
  swiperInstance1.value = swiper;
};
const slidePrev1 = () => {
  if (swiperInstance1.value) {
    swiperInstance1.value.slidePrev();
  }
};
const slideNext1 = () => {
  if (swiperInstance1.value) {
    swiperInstance1.value.slideNext();
  }
};
//-------------------------------------------copy
const onSwiper2 = (swiper) => {
  swiperInstance2.value = swiper;
};
const slidePrev2 = () => {
  if (swiperInstance2.value) {
    swiperInstance2.value.slidePrev();
  }
};
const slideNext2 = () => {
  if (swiperInstance2.value) {
    swiperInstance2.value.slideNext();
  }
};

</script>

<style lang="less" scoped>
.home {
  background-image: url('../assets/home-one-bg.png') !important;
  background-size: cover;
  // /* 使用 cover 以确保背景图片覆盖整个容器 */
  background-repeat: no-repeat;
  background-position: 50% 50%;
  background-color: #fff;

  min-height: 120vh;
  position: relative;
  /* 确保子元素可以绝对定位 */
  overflow: hidden;
  /* 隐藏溢出的内容 */
  -webkit-clip-path: polygon(0 0, 100% 0, 100% 100%, 0 80%);
  clip-path: polygon(0 0, 100% 0, 100% 100%, 0 80%);

  .ulmenu {
    display: flex;
    gap: 4vw;
    flex-direction: column-reverse;
    position: absolute;
    left: 3%;
    top: 20%;
    list-style: none;

    >li {
      cursor: pointer;
      list-style-type: none;
    }
  }
}

.home-two {
  margin-top: -290px;
  background-image: url('../assets/home-two-bg.jpg');
  background-size: cover;
  background-repeat: no-repeat;
  background-position: 50% 50%;
  min-height: 140vh;
  -webkit-clip-path: polygon(0 0, 100% 20%, 100% 100%, 0 75%);
  clip-path: polygon(0 0, 100% 20%, 100% 100%, 0 75%);
  padding: 50px 0px;

  .home-two-title {
    text-transform: uppercase;
    margin-top: -30px;
    font-weight: 600;
    letter-spacing: 1px;
    color: #fff;
    text-align: left;
    padding: 10vw 6vw;
    font-size: 1.6vw;
  }

  .home-two-content {
    .contents {
      display: flex;
      flex-wrap: wrap;
      transform: skewY(10deg);
      color: #fff;
      text-align: left;
      margin: 0px 5%;
      justify-content: center;

      >div {
        line-height: 2;

        &:hover {
          text-align: center;
        }

        >div {
          transform: skewY(-10deg);
          padding: 80px 30px;

          >h3 {
            font-size: 2vw;
            margin: 0px;
            padding: 0px;
          }

          >p {
            margin: 0px;
            padding: 0px;
          }
        }
      }

      >div:nth-child(1) {
        border-width: 2px !important;
        border-color: hsla(0, 0%, 100%, .25) !important;
        border-bottom: 2px solid #e9ecef !important;
        border-right: 2px solid #e9ecef !important;
        flex: 0 0 45%;
      }

      >div:nth-child(2) {
        border-width: 2px !important;
        border-color: hsla(0, 0%, 100%, .25) !important;
        border-bottom: 2px solid #e9ecef !important;
        flex: 0 0 45%;
      }

      >div:nth-child(3) {
        border-color: hsla(0, 0%, 100%, .25) !important;
        border-right: 2px solid #e9ecef !important;
        flex: 0 0 28%;
      }

      >div:nth-child(4) {
        border-color: hsla(0, 0%, 100%, .25) !important;
        border-right: 2px solid #e9ecef !important;
        flex: 0 0 28%;
      }

      >div:nth-child(5) {
        flex: 0 0 28%;
      }
    }
  }
}

.home-three {
  margin-top: -270px;
  aspect-ratio: 4/2;
  // min-height: 400px;
  -webkit-clip-path: polygon(0 0, 100% 25%, 100% 100%, 0 75%);
  clip-path: polygon(0 0, 100% 25%, 100% 100%, 0 75%);
  color: #181614;

  .home-three-title {
    text-transform: uppercase;
    margin-top: -30px;
    font-weight: 600;
    letter-spacing: 1px;
    text-align: left;
    padding: 10vw 6vw;
    font-size: max(1.6vw,12px);
  }

  .swiper-container {
    width: 90%;
    margin: auto;
    height: 100%;
    overflow: visible;

    .swiper-container1 {
      position: relative;

      .swiper-button-prev,
      .swiper-button-next {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        width: 50px;
        height: 50px;
        color: white;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        z-index: 10;

        &::after {
          content: none;
        }
      }

      .swiper-button-prev {
        top: 20%;
        left: -70px;
        transform: rotate(180deg);
      }

      .swiper-button-next {
        right: -70px;
        top: 80%;
      }

      .slide-content {
        display: flex;
        justify-content: center;
        flex-direction: column;
        text-align: left;

        >img {
          width: 20%;
          margin-bottom: 10px;
        }

        h1 {
          font-size: max(1.5vw,12px);
          margin-bottom: 5px;
        }

        h3 {
          font-size: max(1.2vw,10px);
          margin-bottom: 0px;
          position: relative;

          &:after {
            content: '';
            display: block;
            width: 30px;
            height: 2px;
            background-color: #000000;
            position: absolute;
            top: -10px;
            left: 0px;
          }
        }

        p {
          font-size: max(1vw,11px);
          line-height: 1.5;
        }

        >div {
          margin-top: 20px;
          background-color: #282725;
          border-radius: 20px;
          width: 64px;
          height: 40px;
          color: #fff;
          font-weight: bold;
          font-size: 24px;
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;
        }
      }
    }
  }
}

.home-six {
  margin-top: -270px;
  background-image: url('../assets/home-six-bg.png');
  background-size: cover;
  background-repeat: no-repeat;
  background-position: 50% 50%;
  min-height: 140vh;
  -webkit-clip-path: polygon(0 0, 100% 25%, 100% 100%, 0 75%);
  clip-path: polygon(0 0, 100% 25%, 100% 100%, 0 75%);
  color: #fff;

  .home-six-title {
    width: 50%;
    margin-top: -30px;
    font-weight: 600;
    letter-spacing: 1px;
    text-align: left;
    padding: 3vw 6vw 2vw 6vw;
    font-size: max(1.4vw,12px);

    >div:nth-child(2) {
      font-weight: 400;
      font-size:max(1.1vw,12px);
      line-height: 2;
      font-family: Space Grotesk, sans-serif !important;
      margin: 8% 0%;
    }

    >div:nth-child(3) {
      background-color: #172d43;
      border-radius: 0 20px 20px 0;
      color: #fff;
      font-family: Space Grotesk, sans-serif;
      font-weight: 300;
      display: inline-block;
      padding: 10px 20px;
      font-size: 1.1vw;
      box-shadow: 0 3px 1px -2px rgba(0, 0, 0, .2), 0 2px 2px 0 rgba(0, 0, 0, .14), 0 1px 5px 0 rgba(0, 0, 0, .12);
    }
  }

  .home-six-content {
    display: flex;
    gap: 3%;
    margin: 5% 10%;
    flex-direction: column;

    >div {
      display: flex;
      text-align: left;
      align-items: center;

      >div {
        font-size: 5vw;
        font-weight: 700;
        color: hsla(0, 0%, 100%, .6);
        margin: 0 15px 0 0;
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 20px;

        >div:nth-child(2) {
          line-height: 1;

          >p:nth-child(1) {
            font-size: 1.5vw;
          }
        }
      }
    }

    >div:nth-child(1) {
      justify-content: start;
    }

    >div:nth-child(2) {
      justify-content: center;
    }

    >div:nth-child(3) {
      justify-content: end;
    }

    >div:nth-child(4) {
      justify-content: start;
    }

    >div:nth-child(5) {
      justify-content: end;
    }
  }
}

.home-fore {
  margin-top: -370px;
  background-image: url('../assets/home-fore-bg.jpg');
  background-size: cover;
  /* 使用 cover 以确保背景图片覆盖整个容器 */
  background-repeat: no-repeat;
  background-position: 50% 50%;
  min-height: 130vh;
  -webkit-clip-path: polygon(0 0, 100% 25%, 100% 100%, 0 75%);
  clip-path: polygon(0 0, 100% 25%, 100% 100%, 0 75%);

  .home-fore-title {
    width: 50%;
    margin-top: -30px;
    font-weight: 600;
    letter-spacing: 1px;
    color: #172d43;
    text-align: left;
    padding: 10vw 6vw;
    font-size: max(1.6vw, 14px);

    >div:nth-child(2) {
      font-weight: 400;
      font-size: max(1.1vw, 12px);
      line-height: 2;
      font-family: Space Grotesk, sans-serif !important;
      margin: 2% 0%;
    }

    >div:nth-child(3) {
      background-color: #172d43;
      border-radius: 0 20px 20px 0;
      color: #fff;
      font-family: Space Grotesk, sans-serif;
      font-weight: 300;
      display: inline-block;
      padding: 10px 20px;
      font-size: max(1vw,12px);
      box-shadow: 0 3px 1px -2px rgba(0, 0, 0, .2), 0 2px 2px 0 rgba(0, 0, 0, .14), 0 1px 5px 0 rgba(0, 0, 0, .12);
    }
  }
}

.home-five {
  width: 100%;
  margin-top: -400px;
  background-image: url('../assets/home-five-bg.png') !important;
  background-repeat: no-repeat;
  background-position: 50% 50%;
  background-size: cover;
  background-color: #fff;
  min-height: 110vh;
  position: relative;
  overflow: hidden;
  color: #fff;
  -webkit-clip-path: polygon(0 0, 100% 25%, 100% 100%, 0 100%);
  clip-path: polygon(0 0, 100% 36%, 100% 100%, 0 100%);
  transition: clip-path 1s ease, -webkit-clip-path 1s ease; // 添加过渡效果
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;


  >h1 {
    font-weight: 500;
    font-size: 3vw;
    font-size: max(3vw, 36px);
    line-height: 1;
    margin: 0px;
  }

  >div {
    text-transform: uppercase;
    background-color: #ff7a59;
    padding: 10px 30px;
    border-radius: 30px;
    cursor: pointer;

    >a {
      color: inherit;
      text-decoration: none;
      outline: none;
    }
  }
}

.typewriter {
  position: absolute;
  top: 6%;
  right: 10%;
  overflow: hidden;
  /* 隐藏溢出的文本 */
  white-space: pre-wrap;
  /* 允许文本换行 */
  margin: 0;
  letter-spacing: 0.15em;
  /* 调整字母间距 */
  color: #1a2e42;
  font-size: 1rem;
  width: 30%;
  max-width: 30%;
  /* 确保最大宽度 */
  padding-right: 4px;
  /* 为光标留出空间 */
  text-align: left;
}

/* 光标闪烁动画 */
@keyframes blink-caret {

  from,
  to {
    border-color: transparent
  }

  50% {
    border-color: #1a2e42
  }

  /* 光标颜色与文本颜色一致 */
}

.typewriter::after {
  content: '';
  border-right: 2px solid #1a2e42;
  /* 打字机光标效果，颜色与文本颜色一致 */
  animation: blink-caret .75s step-end infinite;
}

@media all and (max-width:600px) {
  .home {
    aspect-ratio: 4/7 !important;
    min-height: 0px;
  }

  .home-two {
    margin-top: -290px;
    min-height: 0px;
    aspect-ratio: 4/4 !important;
    -webkit-clip-path: polygon(0 0, 100% 10%, 100% 100%, 0 90%);
    clip-path: polygon(0 0, 100% 10%, 100% 100%, 0 90%);

    .swiper-container1 {
      position: relative;
      margin: 15% auto !important;

      .swiper-button-prev,
      .swiper-button-next {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        width: 50px;
        height: 50px;
        color: white;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        z-index: 10;

        &::after {
          content: none;
        }
      }

      .swiper-button-prev {
        top: 20%;
        left: 0px;
      }

      .swiper-button-next {
        right: 0px;
        top: 130%;
        transform: rotate(180deg);
      }
    }
  }

  .home-three {
    margin-top: -100px !important;
    aspect-ratio: 4/6 !important;
    -webkit-clip-path: polygon(0 0, 100% 25%, 100% 100%, 0 75%);
    clip-path: polygon(0 0, 100% 25%, 100% 100%, 0 75%);
    color: #181614;
    z-index: 200;

    .home-three-title {
      >h1 {
        margin-top: 15vw;
      }
    }

    .swiper-container {
      .swiper-container1 {
        .swiper-button-prev {
          top: 10%;
          left: 0px;
          transform: rotate(180deg);
        }

        .swiper-button-next {
          right: 0px;
          top: 90%;
        }

        .slide-content {
          text-align: center;
          align-items: center;

          h3 {
            &:after {
              content: '';
              display: block;
              width: 30px;
              height: 2px;
              background-color: #000000;
              position: absolute;
              top: -10px;
              left: 50%;
              transform: translateX(-50%);
            }
          }

          >img {
            // width: 20vw;
          }
        }
      }
    }
  }

  .home-fore {
    aspect-ratio: 4/5 !important;
    min-height: 0px;
    -webkit-clip-path: polygon(0 0, 100% 10%, 100% 100%, 0 90%) !important;
    clip-path: polygon(0 0, 100% 10%, 100% 100%, 0 90%) !important;
    position: relative;
    z-index: 100;

    .home-fore-title {
      position: absolute;
      top: 20%;
      left: 50%;
      transform: translateX(-50%);
      width: 80%;
    }
  }

  .home-six {
    margin-top: -290px;
    min-height: 0px;
    aspect-ratio: 4/8 !important;

    -webkit-clip-path: polygon(0 0, 100% 10%, 100% 100%, 0 90%);
    clip-path: polygon(0 0, 100% 10%, 100% 100%, 0 90%);

    .home-six-title {
      width: 90%;
      >h1 {
        margin-top: 10vw;
      }
    }
    .swiper-container1 {
      position: relative;
      margin: 10% auto !important;

      .swiper-button-prev,
      .swiper-button-next {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        width: 50px;
        height: 50px;
        color: white;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        z-index: 10;

        &::after {
          content: none;
        }
      }

      .swiper-button-prev {
        top: -10%;
        left: 0px;
      }

      .swiper-button-next {
        right: 0px;
        top: 140%;
        transform: rotate(180deg);
      }

      .slide-content {
        display: flex;
        justify-content: center;
        flex-direction: column;
        text-align: left;
      }
      .six-slide{
        display: flex;
        justify-content: center;
        align-items: center;
        >div:nth-child(1){
          font-size: 36px;
          font-weight: bold;
        }
        p{
          text-align: left;
          margin: 0px;
          padding: 0px;
        }
      }
    }
  }

  .home-five {
    min-height: 100vh;

    h1 {
      margin-top: 30vh;
    }

    h3 {
      width: 80%;
    }
  }

  .typewriter {
    top: 20%;
    right: 6%;
    width: 80%;
    max-width: 80%;
  }
}

@media all and (max-width:1200px) {
  .home-three {
    margin-top: -270px;
    aspect-ratio: 4/3;
    -webkit-clip-path: polygon(0 0, 100% 25%, 100% 100%, 0 75%);
    clip-path: polygon(0 0, 100% 25%, 100% 100%, 0 75%);
    color: #181614;
  }
}
</style>